function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { sdkLogger } from '../../../logger';
import { PerfKey, perfLogger, PerfTag } from '../../../utils/perf';
import { VideoStartupStates } from '../video-startup/video-startup-states';
import { PrefetchFailureTypes, PrefetchStatus } from './prefetch.enums';
import { checkIsManifestLinearType } from '../../../utils/playback-type';
export { PrefetchFailureTypes, PrefetchStatus } from './prefetch.enums';
// Todo - it may be useful to store prefetch failure types somewhere and then
// Report them to conviva or verbose logging.
export var PrefetchItem = /*#__PURE__*/ function() {
    "use strict";
    function PrefetchItem(videoStartupController, videoPlatformIntegration, sessionItem, destroyHandler, includeAdsPrefetchWhenPossible) {
        _class_call_check(this, PrefetchItem);
        _define_property(this, "videoStartupController", void 0);
        _define_property(this, "videoPlatformIntegration", void 0);
        _define_property(this, "sessionItem", void 0);
        _define_property(this, "destroyHandler", void 0);
        _define_property(this, "includeAdsPrefetchWhenPossible", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "_lastPrefetchStage", void 0);
        _define_property(this, "_isPrefetchLocked", void 0);
        _define_property(this, "_prefetchPromise", void 0);
        _define_property(this, "_status", void 0);
        this.videoStartupController = videoStartupController;
        this.videoPlatformIntegration = videoPlatformIntegration;
        this.sessionItem = sessionItem;
        this.destroyHandler = destroyHandler;
        this.includeAdsPrefetchWhenPossible = includeAdsPrefetchWhenPossible;
        this.logger = sdkLogger.withContext('Prefetch');
        this._isPrefetchLocked = false;
        this._prefetchPromise = null;
        this._status = PrefetchStatus.Uninitialised;
        this._lastPrefetchStage = this.videoStartupController.state;
    }
    _create_class(PrefetchItem, [
        {
            key: "isFinished",
            get: function get() {
                return this._status === PrefetchStatus.Finished;
            }
        },
        {
            key: "isActive",
            get: function get() {
                return this._status === PrefetchStatus.Active;
            }
        },
        {
            key: "isPaused",
            get: function get() {
                return this._status === PrefetchStatus.Paused;
            }
        },
        {
            key: "isDestroyed",
            get: function get() {
                return this._status === PrefetchStatus.Destroyed;
            }
        },
        {
            key: "hasPrefetchEnded",
            get: function get() {
                return this.isFinished || this.isDestroyed;
            }
        },
        {
            key: "shouldStopPrefetch",
            get: function get() {
                return this.hasPrefetchEnded || this.isPaused;
            }
        },
        {
            key: "mapVamFailureStatusToPrefetchFailureType",
            value: function mapVamFailureStatusToPrefetchFailureType(status) {
                if (status === 204) {
                    return PrefetchFailureTypes.VamNoContent;
                } else if (status === 403) {
                    return PrefetchFailureTypes.VamUnauthorized;
                } else if (status !== 200) {
                    return PrefetchFailureTypes.VamFailure;
                }
            }
        },
        {
            key: "lockPrefetchStage",
            value: function lockPrefetchStage() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_videoStartupController_engineStarter;
                    return _ts_generator(this, function(_state) {
                        if (_this._isPrefetchLocked || _this._prefetchPromise === null) {
                            return [
                                2
                            ];
                        }
                        _this._lastPrefetchStage = _this.videoStartupController.state;
                        _this._isPrefetchLocked = true;
                        _this._status = PrefetchStatus.Finished;
                        (_this_videoStartupController_engineStarter = _this.videoStartupController.engineStarter) === null || _this_videoStartupController_engineStarter === void 0 ? void 0 : _this_videoStartupController_engineStarter.unregisterPeiPrecursorErrorsObservable();
                        return [
                            2,
                            _this._prefetchPromise
                        ];
                    });
                })();
            }
        },
        {
            key: "getLastPrefetchStage",
            value: function getLastPrefetchStage() {
                return this._lastPrefetchStage.type();
            }
        },
        {
            key: "isPrefetchLocked",
            get: function get() {
                return this._isPrefetchLocked;
            }
        },
        {
            key: "setPrefetchIsFinished",
            value: function setPrefetchIsFinished() {
                this._status = PrefetchStatus.Finished;
                this.logger.verbose("Prefetch is finished");
            }
        },
        {
            key: "handleStopOnSLEPreroll",
            value: function handleStopOnSLEPreroll() {
                var vamPrerollEnabled = this.videoStartupController.cachedModifiedPlayoutData.vamPrerollEnabled;
                if (vamPrerollEnabled) {
                    this.setPrefetchIsFinished();
                }
            }
        },
        {
            key: "prefetchVamFailuresHandler",
            value: function prefetchVamFailuresHandler(vamFailureStatus) {
                var videoStartupFailureType = this.mapVamFailureStatusToPrefetchFailureType(vamFailureStatus);
                if (videoStartupFailureType === PrefetchFailureTypes.VamFailure) {
                    this.videoStartupController.discard();
                    this.setPrefetchIsFinished();
                }
                if (videoStartupFailureType === PrefetchFailureTypes.VamNoContent || videoStartupFailureType === PrefetchFailureTypes.VamUnauthorized) {
                    this.videoStartupController.skipAdvertisement();
                }
            }
        },
        {
            key: "handlePrefetchOnVam",
            value: function handlePrefetchOnVam() {
                var vamFailureStatus = this.videoStartupController.cachedModifiedPlayoutData.vamFailureStatus;
                if (vamFailureStatus) {
                    this.prefetchVamFailuresHandler(vamFailureStatus);
                }
            }
        },
        {
            key: "handleAdsFailure",
            value: function handleAdsFailure() {
                var adsFailoverReason = this.videoStartupController.cachedModifiedPlayoutData.adsFailoverReason;
                if (adsFailoverReason) {
                    this.videoStartupController.discard();
                    this.setPrefetchIsFinished();
                }
            }
        },
        {
            key: "handleVideoStartupFailure",
            value: function handleVideoStartupFailure() {
                var _this = this;
                this.videoStartupController.engineStarter.onPeiPrecursorErrorsObservable(function() {
                    _this.setPrefetchIsFinished();
                    _this.videoStartupController.discard();
                });
            }
        },
        {
            key: "handleStartVideoEngine",
            value: function handleStartVideoEngine() {
                this.videoStartupController.createEngineStarter(this.sessionItem);
                this.handleVideoStartupFailure();
                return this.videoStartupController.startEngine(this.sessionItem, {
                    isPrefetch: true
                });
            }
        },
        {
            key: "prefetch",
            value: function prefetch() {
                var _this = this;
                return _async_to_generator(function() {
                    var uninitialisedStates, isVideoProviderCalled, isVamCalled, areAdsBootstrapped, isAdInsertionCalled, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    ,
                                    15
                                ]);
                                uninitialisedStates = [
                                    VideoStartupStates.Uninitialised,
                                    VideoStartupStates.Discarded
                                ];
                                if (uninitialisedStates.includes(_this.videoStartupController.state.type())) {
                                    _this.videoStartupController.initialise();
                                }
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.Initialised)) return [
                                    3,
                                    2
                                ];
                                _this._prefetchPromise = _this.videoStartupController.callVideoProvider(_this.sessionItem, _this.videoPlatformIntegration, true);
                                return [
                                    4,
                                    _this._prefetchPromise
                                ];
                            case 1:
                                isVideoProviderCalled = _state.sent();
                                if (isVideoProviderCalled) {
                                    _this.handleStopOnSLEPreroll();
                                }
                                _state.label = 2;
                            case 2:
                                if (_this.shouldStopPrefetch) {
                                    return [
                                        2
                                    ];
                                }
                                if (_this.videoStartupController.state.type() === VideoStartupStates.VideoProviderCalled) {
                                    _this.videoStartupController.initialiseAdverts(_this.sessionItem);
                                }
                                if (_this.shouldStopPrefetch) {
                                    return [
                                        2
                                    ];
                                }
                                if (!_this.videoStartupController.shouldSkipAdvertisements) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.tryToStartVideoEngine()
                                ];
                            case 3:
                                _state.sent();
                                _this.setPrefetchIsFinished();
                                return [
                                    2
                                ];
                            case 4:
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.AdvertsInitialised)) return [
                                    3,
                                    6
                                ];
                                _this._prefetchPromise = _this.videoStartupController.callVam(_this.sessionItem, {
                                    isPrefetch: true
                                });
                                return [
                                    4,
                                    _this._prefetchPromise
                                ];
                            case 5:
                                isVamCalled = _state.sent();
                                if (isVamCalled) {
                                    _this.handlePrefetchOnVam();
                                }
                                _state.label = 6;
                            case 6:
                                if (_this.shouldStopPrefetch) {
                                    return [
                                        2
                                    ];
                                }
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.VamCalled)) return [
                                    3,
                                    8
                                ];
                                _this._prefetchPromise = _this.videoStartupController.bootstrapAds();
                                return [
                                    4,
                                    _this._prefetchPromise
                                ];
                            case 7:
                                areAdsBootstrapped = _state.sent();
                                if (!areAdsBootstrapped) {
                                    _this.handleAdsFailure();
                                } else if (!_this.includeAdsPrefetchWhenPossible) {
                                    _this.setPrefetchIsFinished();
                                }
                                _state.label = 8;
                            case 8:
                                if (_this.shouldStopPrefetch) {
                                    return [
                                        2
                                    ];
                                }
                                if (!_this.videoStartupController.shouldSkipAdvertisements) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _this.tryToStartVideoEngine()
                                ];
                            case 9:
                                _state.sent();
                                _this.setPrefetchIsFinished();
                                return [
                                    2
                                ];
                            case 10:
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.AdsBootstrapped)) return [
                                    3,
                                    12
                                ];
                                _this._prefetchPromise = _this.videoStartupController.callAdsData();
                                return [
                                    4,
                                    _this._prefetchPromise
                                ];
                            case 11:
                                isAdInsertionCalled = _state.sent();
                                if (isAdInsertionCalled) {
                                    _this.handleAdsFailure();
                                }
                                perfLogger.measure(PerfKey.root, PerfTag.playoutModified);
                                _state.label = 12;
                            case 12:
                                if (_this.shouldStopPrefetch) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.tryToStartVideoEngine()
                                ];
                            case 13:
                                _state.sent();
                                _this.setPrefetchIsFinished();
                                return [
                                    3,
                                    15
                                ];
                            case 14:
                                e = _state.sent();
                                _this.videoStartupController.discard();
                                _this.setPrefetchIsFinished();
                                throw e;
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.isFinished || this.isDestroyed) {
                    this.logger.verbose("Cannot pause a ".concat(this.status, " prefetch"));
                    return;
                }
                this._status = PrefetchStatus.Paused;
                this.logger.verbose('Prefetch is paused');
            }
        },
        {
            key: "resume",
            value: function resume() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.hasPrefetchEnded || _this.isActive) {
                                    _this.logger.verbose("Cannot resume a ".concat(_this.status, " prefetch"));
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                return [
                                    4,
                                    _this._prefetchPromise
                                ];
                            case 1:
                                _state.sent();
                                if (_this.isActive) {
                                    // Prevent Race condition and resuming twice while waiting for promise to resolve
                                    return [
                                        2
                                    ];
                                }
                                _this._status = PrefetchStatus.Active;
                                _this.logger.verbose('Prefetch is resumed');
                                return [
                                    2,
                                    _this.prefetch()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.isDestroyed) {
                    this.logger.verbose('Cannot cancel a destroyed prefetch');
                    return;
                }
                this._status = PrefetchStatus.Destroyed;
                this.destroyHandler();
            }
        },
        {
            key: "status",
            get: function get() {
                return this._status;
            }
        },
        {
            key: "tryToStartVideoEngine",
            value: function tryToStartVideoEngine() {
                var _this = this;
                return _async_to_generator(function() {
                    var isLinearType;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isLinearType = checkIsManifestLinearType(_this.sessionItem.type);
                                if (!!isLinearType) return [
                                    3,
                                    2
                                ];
                                _this._prefetchPromise = _this.handleStartVideoEngine();
                                return [
                                    4,
                                    _this._prefetchPromise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PrefetchItem;
}();

//# sourceMappingURL=prefetch-item.js.map